import dayjs from "dayjs";

import { AlertTypeEnum } from "@/constants";

import { IAlertItem, getAirportNameByCode } from "../utils";

export const SORT_OPTIONS = [
  {
    value: 1,
    label: `Update Time`,
    fn: (a: IAlertItem, b: IAlertItem) => {
      if (!a.targetData?.version || !b.targetData?.version) {
        return -1;
      }
      return Number(b.targetData.version) - Number(a.targetData.version);
    },
  },
  {
    value: 2,
    label: `Departure Date`,
    fn: (a: IAlertItem, b: IAlertItem) => {
      return dayjs(a.info.departureDate).unix() - dayjs(b.info.departureDate).unix();
    },
  },
  {
    value: 3,
    label: `Arrival Date`,
    fn: (a: IAlertItem, b: IAlertItem) => {
      return dayjs(a.info.departureDateSec).unix() - dayjs(b.info.departureDateSec).unix();
    },
  },
  {
    value: 4,
    label: `Newest to Oldest`,
    fn: (a: IAlertItem, b: IAlertItem) => {
      console.log(a);

      const a1 = Number(a.generate_time.replaceAll("-", "").replaceAll(":", ""));
      const b1 = Number(b.generate_time.replaceAll("-", "").replaceAll(":", ""));
      return b1 - a1;
    },
  },
];

const FLIGHT_SORT_OPTIONS = [
  ...SORT_OPTIONS,
  {
    value: 5,
    label: `Departure City`,
    fn: (a: IAlertItem, b: IAlertItem) => {
      return getAirportNameByCode(a.info.departure[0]).localeCompare(
        getAirportNameByCode(b.info.departure[0])
      );
    },
  },
  {
    value: 6,
    label: `Arrival City`,
    fn: (a: IAlertItem, b: IAlertItem) => {
      return getAirportNameByCode(a.info.arrival[0]).localeCompare(
        getAirportNameByCode(b.info.arrival[0])
      );
    },
  },
];

const HOTEL_SORT_OPTIONS = [
  ...SORT_OPTIONS,
  {
    value: 5,
    label: `HotelName`,
    fn: (a: IAlertItem, b: IAlertItem) => {
      return a.info.hotelName[0].localeCompare(b.info.hotelName[0]);
    },
  },
];

export const getOptions = (type: AlertTypeEnum) => {
  const options = type === AlertTypeEnum.Hotel ? HOTEL_SORT_OPTIONS : FLIGHT_SORT_OPTIONS;
  return options;
};

/**
 * 排序
 */
export const getSortFn = (type: AlertTypeEnum) => {
  const options = getOptions(type);
  return (list: IAlertItem[], sortKey: number): IAlertItem[] => {
    const targetSort = options.find((item) => item.value === sortKey);
    return targetSort?.fn ? list.sort(targetSort?.fn) : list;
  };
};
